export enum UserTypes {
  user = "user",
  psychologist = "psychologist",
  admin = "admin",
}

export type UserType = keyof typeof UserTypes;
